import { useMemo } from "react"
import { CONTENT_SET_TEMPLATE_PREFIX } from "connected-components/graph/components/template-selector"
import { useContentSetsMetadata } from "resources/content-sets"
import { ContentSetMetadata } from "./types"
import { useGraphData } from "../../hooks/use-graph-data"

interface ActiveContentSetResult {
  selectedContentSetId: string | null
  activeContentSet: ContentSetMetadata | null
}

export function useActiveContentSet(): ActiveContentSetResult {
  const { selectedTemplate } = useGraphData()
  const [contentSetsMetadata] = useContentSetsMetadata() as [ContentSetMetadata[] | null, string]

  const selectedContentSetId = selectedTemplate?.startsWith(CONTENT_SET_TEMPLATE_PREFIX)
    ? selectedTemplate.slice(CONTENT_SET_TEMPLATE_PREFIX.length)
    : null

  const activeContentSet = useMemo((): ContentSetMetadata | null => {
    if (!contentSetsMetadata || !selectedContentSetId) return null
    return contentSetsMetadata.find(cs => cs.id === selectedContentSetId) ?? null
  }, [contentSetsMetadata, selectedContentSetId])

  return { selectedContentSetId, activeContentSet }
}
